import React, { useEffect } from "react";
import IrregularitiesPage from "../../../Irregularities";
import { useDispatch, useSelector } from "react-redux";
import { setIrregularitiesDetails, setIrregularitiesLoading, setIrregularitiesError } from "../../../../../store/reducers/slices/irregularities.slice";
// import { Irregularities } from "../../../../../utils/JsonData/irregularities";
import { getIrregularities } from "../../../../../api/Irregularities";

const IrregularitiesPageWrapper = () => {
    const dispatch = useDispatch();
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    // API and redux
    useEffect(() => {
        // dispatch(setIrregularitiesLoading(true));
        // if (!irregularitiesDetails) {
        //     dispatch(setIrregularitiesDetails(Irregularities));
        // }
        // dispatch(setIrregularitiesLoading(false));
        const fetchData = async () => {
            try {
                let aggregate = selectedAccountId !== 'all'? false : true;
                let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
                const response = await getIrregularities(account_id, aggregate);
                dispatch(setIrregularitiesDetails(response));
                dispatch(setIrregularitiesLoading(false));
            } catch (error) {
                dispatch(setIrregularitiesLoading(false));
                dispatch(setIrregularitiesError(error.message));
                console.log("ERROR", error);
            }
        }

        if (selectedAccountId) {
            fetchData();
        }
        // else {
        //     dispatch(setIrregularitiesLoading(false));
        // }
    }, [selectedAccountId])

    return (
        <IrregularitiesPage />
    );
};

export default IrregularitiesPageWrapper;
